<template>
  <div class="terms-and-conditions-container pb-xl-6 pb-lg-6 pb-md-2 pb-sm-2 pb-3">
    <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pt-sm-0 pt-0 px-xl-4 px-lg-4 px-md-4 px-sm-0 px-0 pb-xl-6 pb-lg-6 pb-md-6 pb-sm-2 pb-1" no-gutters>
      <v-col xl="8" lg="9" md="10" sm="11" cols="11" v-if="$vuetify.breakpoint.mdAndUp">
        <div class="text-left headline font-weight-bold section-title mt-1 mb-4">
          Términos y condiciones de uso del sitio
        </div>
      </v-col>
      <v-col xl="8" lg="9" md="10" sm="12" cols="12">
        <v-card class="mx-auto text-left pt-3 pb-7" tile :flat="$vuetify.breakpoint.smAndDown">
          <div class="text-center title font-weight-bold section-title mt-2" v-if="$vuetify.breakpoint.smAndDown">
            Términos y condiciones de uso del sitio
          </div>
          <v-row justify="center" class="pt-xl-4 pt-lg-2 pt-md-4 pt-sm-0 pt-0" no-gutters>
            <v-col xl="11" lg="11" md="11" sm="11" cols="11">
              <v-row justify="center">
                <v-col cols="12">
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Versión vigente 17/11/2019
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Este contrato describe los términos y condiciones
                      generales aplicables al uso de los servicios ofrecidos por
                      <span class="font-weight-bold">{{ appName }}</span>.
                      Cualquier persona que desee acceder
                      y/o usar el sitio o los servicios podrá hacerlo sujetándose a los
                      Términos y Condiciones Generales, junto con todas las demás políticas
                      y principios que rigen
                      <span class="font-weight-bold">{{ appName }}</span> y que son
                      incorporados al presente por referencia.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary font-weight-bold">
                      lOS TERMINOS Y CONDICIONES GENERALES SON DE CARÁCTER
                      OBLIGATORIO Y VINCULANTE, LA PERSONA QUE NO LOS ACEPTE
                      DEBERÁ ABSTENERSE DE UTILIZAR EL SITIO Y/O LOS
                      SERVICIOS.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="text--primary">
                      El usuario debe leer, entender y aceptar todas las
                      condiciones establecidas en los Términos y Condiciones
                      Generales y en las Políticas de Privacidad, así como en
                      los demás documentos incorporados a los mismos por
                      referencia, previo a su inscripción como Usuario de
                      <span class="font-weight-bold">{{ appName }}</span>.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    01 - Capacidad
                  </div>
                  <div class="body-2 mt-2 text-muted font-weight-light">
                    <span class="text--primary">
                      Los servicios están disponibles para cualquier persona. No
                      podrán utilizar los servicios de <span class="font-weight-bold">{{ appName }}</span>
                      los usuarios que hayan sido suspendidos temporalmente o
                      inhabilitados definitivamente.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    02 - Inscripción
                  </div>
                  <div class="body-2 mt-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Es obligatorio completar el formulario de inscripción en
                      todos sus campos con datos válidos para poder utilizar los
                      servicios que brinda {{ appName }}. El futuro Usuario
                      deberá completarlo con su información personal de manera
                      exacta, precisa y verdadera ("Mi Perfil") y asume el
                      compromiso de actualizarlos conforme resulte necesario.
                      {{ appName }} podrá utilizar diversos medios para
                      identificar a sus Usuarios, pero {{ appName }} NO se
                      responsabiliza por la certeza de los Datos provistos por
                      sus Usuarios. Los Usuarios garantizan y responden, en
                      cualquier caso, de la veracidad, exactitud, vigencia y
                      autenticidad de los Datos ingresados.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      {{ appName }} se reserva el derecho de solicitar algún
                      comprobante y/o dato adicional a efectos de corroborar los
                      Datos Personales, así como de suspender temporal o
                      definitivamente a aquellos Usuarios que incumplan las
                      politicas de <span class="font-weight-bold">{{ appName }}</span>
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      El Usuario accederá a su cuenta personal ("Cuenta")
                      mediante el ingreso de su Seudónimo y clave de seguridad
                      personal elegida ("Clave de Seguridad"). El Usuario se
                      obliga a mantener la confidencialidad de su clave de
                      seguridad.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      La Cuenta es personal, única e intransferible, y está
                      prohibido que un mismo Usuario inscriba o posea más de una
                      Cuenta. En caso que {{ appName }} detecte distintas
                      Cuentas que contengan los mismos datos o relacionados,
                      podrá cancelar, suspender o inhabilitarlas.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="text--primary">
                      El Usuario será responsable por todas las operaciones
                      efectuadas en su Cuenta, pues el acceso a la misma está
                      restringido al ingreso y uso de su Clave de Seguridad, de
                      conocimiento exclusivo del Usuario. El Usuario se
                      compromete a notificar a {{ appName }} en forma inmediata
                      y por medio idóneo y fehaciente, cualquier uso no
                      autorizado de su Cuenta, así como el ingreso por terceros
                      no autorizados a la misma.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    03 - Modificaciones del Acuerdo
                  </div>
                  <div class="body-2 mt-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      {{ appName }} podrá modificar los Términos y Condiciones
                      Generales en cualquier momento haciendo públicos en el
                      Sitio los términos modificados. Todos los términos
                      modificados entrarán en vigor a los 10 (diez) días de su
                      publicación. Dichas modificaciones serán comunicadas por
                      {{ appName }} a los usuarios que en la Configuración de su
                      Cuenta de {{ appName }} hayan indicado que desean recibir
                      notificaciones de los cambios en estos Términos y
                      Condiciones. Todo usuario que no esté de acuerdo con las
                      modificaciones efectuadas por {{ appName }} podrá
                      solicitar la baja de la cuenta.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="text--primary">
                      El uso del sitio y/o sus servicios implica la aceptación
                      de estos Términos y Condiciones generales de uso de
                      {{ appName }}.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    04 - Privacidad de la Información
                  </div>
                  <div class="body-2 mt-2 text-muted font-weight-light">
                    <span class="text--primary">
                      Para utilizar los Servicios ofrecidos por {{ appName }},
                      los Usuarios deberán facilitar determinados datos de
                      carácter personal. Su información personal se procesa y
                      almacena en servidores o medios magnéticos que mantienen
                      altos estándares de seguridad y protección tanto física
                      como tecnológica. Para mayor información sobre la
                      privacidad de los Datos Personales y casos en los que será
                      revelada la información personal, se pueden consultar
                      nuestras
                      <a class="blue--text text--darken-3" @click="goToRouteByName('Privacy-policies')">
                        Políticas de Privacidad
                      </a>.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    05 - Obligaciones de los Usuarios
                  </div>
                  <div class="body-2 mt-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      La compra es irrevocable salvo en circunstancias
                      excepcionales, tales como que exista un claro error
                      tipográfico, o que el articulo este agorado. La compra
                      sólo serán consideradas válidas, una vez que hayan sido
                      procesadas por el sistema informático de {{ appName }}.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="text--primary">
                      {{ appName }} será responsable por todas las obligaciones
                      y cargas impositivas que correspondan por la venta de sus
                      articulos. {{ appName }} acepta que los compradores podrán
                      iniciar reclamos por haber recibido un producto defectuoso
                      o diferente dentro de los 10 días calendario de haberlo
                      recibido. en caso de que el comprador tenga razon en su
                      reclamo {{ appName }} aceptara el cambio o devolución del
                      producto vendido y podrá hacerse cargo de los gastos que
                      esto conlleve.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    06 - Sanciones
                  </div>
                  <div class="body-2 mt-2 text-muted font-weight-light">
                    <span class="text--primary">
                      Sin perjuicio de otras medidas, {{ appName }} podrá
                      advertir, suspender en forma temporal o inhabilitar
                      definitivamente la Cuenta de un Usuario, iniciar las
                      acciones que estime pertinentes si se quebrantara alguna
                      ley, o cualquiera de las estipulaciones de los Términos y
                      Condiciones Generales y demás políticas de {{ appName }},
                      si incumpliera sus compromisos como Usuario, si se
                      incurriera a criterio de {{ appName }} en conductas o
                      actos dolosos o fraudulentos, no pudiera verificarse la
                      identidad del Usuario o cualquier información
                      proporcionada por el mismo fuere errónea.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    07 - Consentimiento de Compra
                  </div>
                  <div class="body-2 mt-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      El consentimiento por parte del consumidor se manifiesta
                      en los pasos de compra en {{ appName }} aceptando cada uno
                      de ellos y se perfecciona con la manifestación final de
                      compra después de haber revisado el resumen del pedido.
                      Antes de la confirmación final de compra, el cliente podrá
                      cancelar la compra en cualquier momento.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="text--primary">
                      {{ appName }} expedirá un acuse de recibo del mismo al
                      correo electrónico registrado por el cliente, con la
                      información del tiempo de entrega, precio exacto,
                      incluyendo los impuestos, gastos de envío y la forma en
                      que se realizó el pago.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    08 - Políticas de Cambios y Devoluciones
                  </div>
                  <div class="body-2 mt-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      En el evento de presentarse defectos en la calidad o
                      idoneidad de los bienes adquiridos a través de
                      {{ appName }}, se podrá hacer uso de la garantía legal en
                      los términos estipulados en los presentes términos y
                      condiciones.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Para que sea procedente realizar cambios y devoluciones se
                      requiere que el objeto de la obligación contractual haya
                      sido defectuoso o inútil para su normal uso. Para que
                      procedan los cambios o devoluciones, se requiere que sea
                      solicitada dentro de los tres meses desde la recepción del
                      bien, en caso de deficiencias de fabricación, elaboración,
                      materiales o en caso de que no sea enteramente apto para
                      el uso o consumo al que está destinado.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      En el evento de expirar el término para hacer la entrega
                      del producto, cuando el producto entregado no corresponda
                      a lo solicitado, o cuando corresponda a una operación no
                      solicitada, los Clientes tendrán derecho a solicitar la
                      resolución o terminación del contrato, y obtener la
                      devolución del dinero de la compra sin que haya lugar a
                      retención o descuento alguno. Dicha devolución se
                      realizara maximo en noventa (90) días calendario.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Para que proceda la devolución del dinero, el producto
                      objeto de la devolución debe estar en las instalaciones de
                      {{ appName }}; para esto, el cliente debe dar aviso al
                      área de servicio al cliente de {{ appName }} de su
                      intención de devolver el producto dentro de los treinta
                      (30) días calendario siguiente a la fecha de la compra
                      inicial, {{ appName }} se encargara de recoger el producto
                      y validar que este se encuentre en las condiciones de
                      devolución exigidas por la compañía.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      El producto debe estar sin uso, con etiquetas, en
                      perfectas condiciones y debe tener los embalajes
                      originales en el caso en que el defecto del bien haya
                      podido ser detectado a primera vista, como por ejemplo
                      cuando se trata de un color, modelo o talla distinto al
                      solicitado.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="text--primary">
                      Pasados los 5 primeros días desde la recepción del
                      producto, no se realizarán cambios ni devoluciones cuando
                      las razones sean atribuibles a gustos o apreciaciones
                      personales del Cliente.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    09 - Garantía
                  </div>
                  <div class="body-2 mt-2 text-muted font-weight-light">
                    <span class="text--primary">
                      Salvo que en {{ appName }} se indique específicamente algo
                      distinto en relación con un producto, los productos que
                      allí se comercializan tendrán una garantía de {{ daysWarranty }} días
                      por defectos de fábrica.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    10 - Violaciones del Sistema o Bases de Datos
                  </div>
                  <div class="body-2 mt-2 text-muted font-weight-light">
                    <span class="text--primary">
                      No se permite ninguna acción o uso de dispositivo,
                      software, u otro medio tendiente a interferir tanto en las
                      actividades y operatoria de {{ appName }} en la venta,
                      descripciones, cuentas o bases de datos de {{ appName }}.
                      Cualquier intromisión, tentativa o actividad violatoria o
                      contraria a las leyes sobre derecho de propiedad
                      intelectual y/o a las prohibiciones estipuladas en este
                      contrato harán pasible a su responsable de las acciones
                      legales pertinentes, y a las sanciones previstas por este
                      acuerdo, así como lo hará responsable de indemnizar los
                      daños ocasionados.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    11 - Fallas en el sistema
                  </div>
                  <div class="body-2 mt-2 text-muted font-weight-light">
                    <span class="text--primary">
                      {{ appName }} no se responsabiliza por cualquier daño,
                      perjuicio o pérdida al Usuario causados por fallas en el
                      sistema, en el servidor o en Internet.
                      {{ appName }} tampoco será responsable por cualquier virus
                      que pudiera infectar el equipo del Usuario como
                      consecuencia del acceso, uso o examen de su sitio web. Los
                      Usuarios NO podrán imputarle responsabilidad alguna ni
                      exigir pago por lucro cesante, en virtud de perjuicios
                      resultantes de dificultades técnicas o fallas en los
                      sistemas o en Internet. {{ appName }} no garantiza el
                      acceso y uso continuado o ininterrumpido de su sitio. El
                      sistema puede eventualmente no estar disponible debido a
                      dificultades técnicas o fallas de Internet, o por
                      cualquier otra circunstancia ajena a {{ appName }}; en
                      tales casos se procurará restablecerlo con la mayor
                      celeridad posible sin que por ello pueda imputársele algún
                      tipo de responsabilidad. {{ appName }} no será responsable
                      por ningún error u omisión contenidos en su sitio web.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    12 - Jurisdicción y Ley Aplicable
                  </div>
                  <div class="body-2 mt-2 text-muted font-weight-light">
                    <span class="text--primary">
                      Este acuerdo estará regido en todos sus puntos por las
                      leyes vigentes en la República de Colombia.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="text--primary">
                      Cualquier controversia derivada del presente acuerdo, su
                      existencia, validez, interpretación, alcance o
                      cumplimiento, será sometida a las leyes aplicables y a los
                      Tribunales competentes de la Ciudad de Cali y los
                      procedimientos se llevarán a cabo en idioma castellano.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    13 - Información Contenida en este Sitio
                  </div>
                  <div class="body-2 mt-2 text-muted font-weight-light">
                    <span class="text--primary">
                      {{ appName }} podrán modificar cualquier información
                      contenida en este sitio, en cualquier momento y sin previo
                      aviso, hasta el momento de la validación de la
                      transacción, la cual obligará a {{ appName }}, sujeto a
                      las condiciones de validación.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    14 - Domicilio
                  </div>
                  <div class="body-2 mt-2 text-muted font-weight-light">
                    <span class="text--primary">
                      Se fija como domicilio de <span class="font-weight-bold">{{ appName }}</span>,
                      con NIT {{ nit }}, la {{ ubication.direction }}, {{ ubication.additional }},
                      {{ ubication.city }} {{ ubication.departament }}, {{ ubication.country }}.
                      Teléfonos (1) {{ phone.cell_phone }} (2) {{ phone.landline }}.
                      Correo {{ email }}
                    </span>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import navigationMixin from '@/mixins/navigation'
import { UBICATION, PHONE, APP_NAME, EMAIL, NIT, DAYS_WARRANTY } from '@/config/local-info'

export default {
  mixins: [navigationMixin],
  data () {
    return {
      appName: APP_NAME,
      ubication: UBICATION,
      phone: PHONE,
      email: EMAIL,
      nit: NIT,
      daysWarranty: DAYS_WARRANTY
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';
  .text-muted {
    line-height: 1.75em;
  }

  .terms-and-conditions-container{
    height: 100%;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .terms-and-conditions-container{
      background-color: #FFFFFF;
    }
  }
</style>
